import { ServiceConfigProviderSetup } from '@volkswagen-onehub/service-config-provider';

export const mockServiceConfig: ServiceConfigProviderSetup = {
  configs: {
    modelsConfig: {
      urlOrigin: 'https://cs-int-vw-us.lighthouselabs.eu/en.html',
      urlPath: '/en.service-config.json',
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: undefined,
      credentials: {
        username: 'username',
        password: 'password',
      },
    },
    offersSharedConfigs: {
      urlOrigin: 'https://qa.vwfiledataimport.svc.vwusa.io',
      urlPath: '/api/config/json/offers-shared-configurations',
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: undefined,
      credentials: undefined,
    },
    'service-config': {
      urlOrigin: 'https://cs-int-vw-us.lighthouselabs.eu/en.html',
      urlPath: '/en.service-config.json',
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: undefined,
      credentials: {
        username: 'username',
        password: 'password',
      },
    },
    vicci: {
      urlOrigin: 'https://vicci-content-cdn.ngw6apps.io',
      urlPath: undefined,
      tenantCommercial: undefined,
      tenantPrivate: 'ihdcc-vw-us-en-cont',
      customConfig: {},
      credentials: {
        username: 'username',
        password: 'password',
      },
    },
    s2f: {
      urlOrigin: 'https://qa.vwoss.svc.vwusa.io',
      urlPath: undefined,
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: {},
      credentials: {
        username: 'username',
        password: 'password',
      },
    },
    i18n: {
      urlOrigin: 'https://ngwsa-content-cdn.ngw6apps.io',
      urlPath: '/i18n/resources/translations',
      tenantCommercial: undefined,
      tenantPrivate: 'vw-us',
      customConfig: {
        mofaTenant: 'vw-us',
        ulfTenant: 'vw-us',
        rootKey: 'ihdcc',
        default: {
          configure: {
            configuration: {
              missing: 'Please set a configuration',
            },
            loading: {
              label: 'Loading...',
              accessibility: {
                loadingMsg: 'Configurator is loading',
                finishedMsg: 'Configurator finished loading',
              },
            },
          },
        },
      },
      credentials: {
        username: 'username',
        password: 'password',
      },
    },
    fiveStars: {
      urlOrigin: 'http://review-api.feedbackferret.com/',
      urlPath: 'api/VWofamerica/reviews/',
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: {},
      credentials: undefined,
    },
    acs: {
      urlOrigin: 'https://ngwsa-content-cdn.ngw6apps.io',
      urlPath: '/acs/resources/configurations',
      tenantCommercial: undefined,
      tenantPrivate: 'vw-us-ca',
      customConfig: {
        mofaTenant: 'vw-us',
        ulfTenant: 'vw-us',
      },
      credentials: {
        username: 'username',
        password: 'password',
      },
    },
    'model-structure': {
      urlOrigin: '',
      urlPath: '/en/tools/model-structure.mofa.json',
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: undefined,
      credentials: {
        username: 'username',
        password: 'password',
      },
    },
    recall: {
      urlOrigin: 'https://www.vw.com',
      urlPath: '/s2f/vwrecall-nhtsa2/vin/',
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: {},
      credentials: undefined,
    },
    s2fHandraiser: {
      urlOrigin: 'https://qa.vw.com',
      urlPath: '/s2f/formhandler',
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: {},
      credentials: {
        username: 'username',
        password: 'password',
      },
    },
    'mofa-cardata': {
      urlOrigin: 'undefined',
      urlPath: '/en/tools/model-structure.mofa-cardata.json',
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: undefined,
      credentials: {
        username: 'username',
        password: 'password',
      },
    },
    sdl: {
      urlOrigin: 'https://qa.vw.com',
      urlPath: undefined,
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: {},
      credentials: {
        username: 'username',
        password: 'password',
      },
    },
    iptozip: {
      urlOrigin: 'https://www.vw.com',
      urlPath: '/en/geolocation-zip.html',
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: {},
      credentials: undefined,
    },
    emissions: {
      urlOrigin: 'https://www.vwdieselinfo.com',
      urlPath: '/tdistatus/vin/',
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: {},
      credentials: undefined,
    },
    'graphql-server': {
      urlOrigin: 'https://qa.vwapollogw.svc.vwusa.io',
      urlPath: '/graphql',
      tenantCommercial: undefined,
      tenantPrivate: undefined,
      customConfig: {},
      credentials: undefined,
    },
    'fa-services': {
      urlOrigin: 'https://qa.vwservicesfa.svc.vwusa.io',
    },
    'offers-config': {
      urlOrigin: '',
      customConfig: {
        mappedTrimName: {
          '2019-allnewjetta-sat': {
            trim: '2019-allnewjetta-sat',
            trimName: 'S - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-jetta-seat': {
            trim: '2019-jetta-seat',
            trimName: 'SE - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-jetta-selat': {
            trim: '2019-jetta-selat',
            trimName: 'SEL - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-jetta-selpat': {
            trim: '2019-jetta-selpat',
            trimName: 'SEL Premium - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-jetta-rlat': {
            trim: '2019-jetta-rlat',
            trimName: 'R-Line - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-allnewjetta-smt': {
            trim: '2019-allnewjetta-smt',
            trimName: 'S - Manual Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-allnewjetta-seat': {
            trim: '2019-allnewjetta-seat',
            trimName: 'SE - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-allnewjetta-rlat': {
            trim: '2019-allnewjetta-rlat',
            trimName: 'R-Line - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-allnewjetta-selat': {
            trim: '2019-allnewjetta-selat',
            trimName: 'SEL - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-allnewjetta-selpat': {
            trim: '2019-allnewjetta-selpat',
            trimName: 'SEL Premium - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-tiguan-sat': {
            trim: '2019-tiguan-sat',
            trimName: '2.0T S - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-tiguan-seat': {
            trim: '2019-tiguan-seat',
            trimName: '2.0T SE - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-tiguan-s4mat': {
            trim: '2019-tiguan-s4mat',
            trimName: '2.0T S with 4MOTION® - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-tiguan-se4mat': {
            trim: '2019-tiguan-se4mat',
            trimName: '2.0T SE with 4MOTION® - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-jetta-smt': {
            trim: '2019-jetta-smt',
            trimName: 'S - Manual Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-jetta-sat': {
            trim: '2019-jetta-sat',
            trimName: 'S - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-atlas-20sat': {
            trim: '2019-atlas-20sat',
            trimName: 'S - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-atlas-v6s4mat': {
            trim: '2019-atlas-v6s4mat',
            trimName: 'V6 S with 4MOTION® - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-atlas-v6se4mat': {
            trim: '2019-atlas-v6se4mat',
            trimName: 'V6 SE with 4MOTION® - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-atlas-v6seat': {
            trim: '2019-atlas-v6seat',
            trimName: 'V6 SE - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-atlas-v6sel4mat': {
            trim: '2019-atlas-v6sel4mat',
            trimName: 'V6 SEL with 4MOTION® - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-atlas-v6selat': {
            trim: '2019-atlas-v6selat',
            trimName: 'V6 SEL - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-atlas-v6selp4mat': {
            trim: '2019-atlas-v6selp4mat',
            trimName: 'V6 SEL Premium with 4MOTION® - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-atlas-v6setech4mat': {
            trim: '2019-atlas-v6setech4mat',
            trimName: 'V6 SE Tech with 4MOTION® - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-atlas-v6setechat': {
            trim: '2019-atlas-v6setechat',
            trimName: 'V6 SE Tech - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-atlas-v6setechrlat': {
            trim: '2019-atlas-v6setechrlat',
            trimName: 'V6 SE Tech R-Line - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-passat-wolfsburgat': {
            trim: '2019-passat-wolfsburgat',
            trimName: '2.0T Wolfsburg - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-passat-serlineat': {
            trim: '2019-passat-serlineat',
            trimName: '2.0T SE R-Line - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-tiguan-selat': {
            trim: '2019-tiguan-selat',
            trimName: '2.0T SEL - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-tiguan-selp4mat': {
            trim: '2019-tiguan-selp4mat',
            trimName:
              '2.0T SEL Premium with 4MOTION® - Automatic Transmission',
            trimInventoryName: 'NULL',
          },
          '2019-gti-smt': {
            trim: '2019-gti-smt',
            trimName: 'S - Manual Transmission',
          },
          '2019-gti-sat': {
            trim: '2019-gti-sat',
            trimName: 'S - Automatic Transmission',
          },
          '2019-gti-semt': {
            trim: '2019-gti-semt',
            trimName: 'SE - Manual Transmission',
          },
          '2019-gti-seat': {
            trim: '2019-gti-seat',
            trimName: 'SE - Automatic Transmission',
          },
          '2019-gti-autobahnmt': {
            trim: '2019-gti-autobahnmt',
            trimName: 'Autobahn - Manual Transmission',
          },
          '2019-gti-autobahnat': {
            trim: '2019-gti-autobahnat',
            trimName: 'Autobahn - Automatic Transmission',
          },
          '2019-gti-rabbitat': {
            trim: '2019-gti-rabbitat',
            trimName: 'Rabbit Edition - Automatic Transmission',
          },
          '2019-gti-rabbitmt': {
            trim: '2019-gti-rabbitmt',
            trimName: 'Rabbit Edition - Manual Transmission',
          },
          '2019-egolf-seat': {
            trim: '2019-egolf-seat',
            trimName: 'SE - Automatic Transmission',
          },
          '2019-golf-14sat': {
            trim: '2019-golf-14sat',
            trimName: 'S - Automatic Transmission',
          },
          '2019-golf-14smt': {
            trim: '2019-golf-14smt',
            trimName: 'S - Manual Transmission',
          },
          '2019-golf-14seat': {
            trim: '2019-golf-14seat',
            trimName: 'SE - Automatic Transmission',
          },
          '2019-golf-14semt': {
            trim: '2019-golf-14semt',
            trimName: 'SE - Manual Transmission',
          },
          '2019-golfgti-smt': {
            trim: '2019-golfgti-smt',
            trimName: 'S - Manual Transmission',
          },
          '2019-golfgti-sat': {
            trim: '2019-golfgti-sat',
            trimName: 'S - Automatic Transmission',
          },
          '2019-golfgti-semt': {
            trim: '2019-golfgti-semt',
            trimName: 'SE - Manual Transmission',
          },
          '2019-golfgti-seat': {
            trim: '2019-golfgti-seat',
            trimName: 'SE - Automatic Transmission',
          },
          '2019-golfgti-autobahnmt': {
            trim: '2019-golfgti-autobahnmt',
            trimName: 'Autobahn - Manual Transmission',
          },
          '2019-golfgti-autobahnat': {
            trim: '2019-golfgti-autobahnat',
            trimName: 'Autobahn - Automatic Transmission',
          },
          '2019-golfgti-rabbitat': {
            trim: '2019-golfgti-rabbitat',
            trimName: 'Rabbit - Automatic Transmission',
          },
          '2019-golfgti-rabbitmt': {
            trim: '2019-golfgti-rabbitmt',
            trimName: 'Rabbit - Manual Transmission',
          },
          '2019-atlas-v6setechrl4mat': {
            trim: '2019-atlas-v6setechrl4mat',
            trimName:
              'V6 SE Tech R-Line with 4MOTION® - Automatic Transmission',
          },
          '2019-jettagli-sat': {
            trim: '2019-jettagli-sat',
            trimName: '2.0T S - Automatic Transmission',
          },
          '2019-arteon-se4mat': {
            trim: '2019-arteon-se4mat',
            trimName: '2.0T SE with 4MOTION® - Automatic Transmission',
          },
          '2019-tiguan-selrlbl4mat': {
            trim: '2019-tiguan-selrlbl4mat',
            trimName:
              '2.0T SEL Black R-Line with 4MOTION® - Automatic Transmission',
          },
          '2019-tiguan-selrl4mat': {
            trim: '2019-tiguan-selrl4mat',
            trimName: '2.0T SEL R-Line with 4MOTION® - Automatic Transmission',
          },
          '2019-tiguan-selprl4mat': {
            trim: '2019-tiguan-selprl4mat',
            trimName:
              '2.0T SEL Premium R-Line with 4MOTION® - Automatic Transmission',
          },
          '2019-atlas-v6selrl4mat': {
            trim: '2019-atlas-v6selrl4mat',
            trimName: 'V6 SEL R-Line with 4MOTION® - Automatic Transmission',
          },
          '2019-atlas-20seat': {
            trim: '2019-atlas-20seat',
            trimName: '2.0 SE - Automatic Transmission',
          },
          '2020-tiguan-sat': {
            trim: '2020-tiguan-sat',
            trimName: 'S - Automatic Transmission',
          },
          '2020-tiguan-s4mat': {
            trim: '2020-tiguan-s4mat',
            trimName: 'S with 4MOTION® - Automatic Transmission',
          },
          '2020-tiguan-seat': {
            trim: '2020-tiguan-seat',
            trimName: 'SE - Automatic Transmission',
          },
          '2020-tiguan-se4mat': {
            trim: '2020-tiguan-se4mat',
            trimName: 'SE with 4MOTION® - Automatic Transmission',
          },
          '2020-tiguan-selat': {
            trim: '2020-tiguan-selat',
            trimName: 'SEL - Automatic Transmission',
          },
          '2020-tiguan-sel4mat': {
            trim: '2020-tiguan-sel4mat',
            trimName: 'SEL with 4MOTION® - Automatic Transmission',
          },
          '2020-tiguan-ser-lb4mat': {
            trim: '2020-tiguan-ser-lb4mat',
            trimName:
              'SE R-Line Black Package with 4MOTION® - Automatic Transmission',
          },
          '2019-jettagli-35theditionat': {
            trim: '2019-jettagli-35theditionat',
            trimName: '2.0T 35th Anniversary Edition - Automatic Transmission',
          },
          '2019-arteon-seat': {
            trim: '2019-arteon-seat',
            trimName: '2.0T SE - Automatic Transmission',
          },
          '2020-passat-sat': {
            trim: '2020-passat-sat',
            trimName: '2.0T S',
          },
          '2020-passat-seat': {
            trim: '2020-passat-seat',
            trimName: '2.0T SE',
          },
          '2020-passat-rlineat': {
            trim: '2020-passat-rlineat',
            trimName: '2.0T R-Line',
          },
          '2020-passat-selat': {
            trim: '2020-passat-selat',
            trimName: '2.0T SEL',
          },
          '2019-egolf-selpat': {
            trim: '2019-egolf-selpat',
            trimName: 'SEL Premium',
          },
          '2020-jetta-smt': {
            trim: '2020-jetta-smt',
            trimName: '1.4T S',
          },
          '2020-jetta-all': {
            trim: '2020-jetta-all',
            trimName: 'ALL',
          },
          '2020-jetta-sat': {
            trim: '2020-jetta-sat',
            trimName: '1.4T S',
          },
          '2020-jetta-seulevat': {
            trim: '2020-jetta-seulevat',
            trimName: '1.4T SE ULEV',
          },
          '2020-jetta-seat': {
            trim: '2020-jetta-seat',
            trimName: '1.4T SE',
          },
          '2020-jetta-selat': {
            trim: '2020-jetta-selat',
            trimName: '1.4T SEL',
          },
          '2020-jetta-selulevat': {
            trim: '2020-jetta-selulevat',
            trimName: '1.4T SEL ULEV',
          },
          '2020-jetta-selpulevat': {
            trim: '2020-jetta-selpulevat',
            trimName: '1.4T SEL Premium ULEV',
          },
          '2020-jetta-selpat': {
            trim: '2020-jetta-selpat',
            trimName: '1.4T SEL Premium',
          },
          '2020-jetta-rlmt': {
            trim: '2020-jetta-rlmt',
            trimName: '1.4T R-Line',
          },
          '2020-jetta-rlat': {
            trim: '2020-jetta-rlat',
            trimName: '1.4T R-Line',
          },
          '2020-jetta-rlulevat': {
            trim: '2020-jetta-rlulevat',
            trimName: '1.4T R-Line ULEV',
          },
          '2020-jetta-sulevat': {
            trim: '2020-jetta-sulevat',
            trimName: '1.4T S ULEV',
          },
          '2020-acs-all': {
            trim: '2020-acs-all',
            trimName: 'ALL',
          },
          '2020-acs-sat': {
            trim: '2020-acs-sat',
            trimName: 'S',
          },
          '2020-acs-s4mat': {
            trim: '2020-acs-s4mat',
            trimName: 'S with 4MOTION®',
          },
          '2020-acs-seat': {
            trim: '2020-acs-seat',
            trimName: 'SE',
          },
          '2020-acs-se4mat': {
            trim: '2020-acs-se4mat',
            trimName: 'SE with 4MOTION®',
          },
          '2020-acs-sewtat': {
            trim: '2020-acs-sewtat',
            trimName: 'SE Tech',
          },
          '2020-acs-sewt4mat': {
            trim: '2020-acs-sewt4mat',
            trimName: 'SE Tech with 4MOTION®',
          },
          '2020-acs-sel4mat': {
            trim: '2020-acs-sel4mat',
            trimName: 'SEL with 4MOTION®',
          },
          '2020-acs-selprl4m': {
            trim: '2020-acs-selprl4m',
            trimName: 'SEL Premium R-Line with 4MOTION®',
          },
          '2020-acs-v6sewt4mat': {
            trim: '2020-acs-v6sewt4mat',
            trimName: 'V6 SE Tech with 4MOTION®',
          },
          '2020-acs-v6sel4mat': {
            trim: '2020-acs-v6sel4mat',
            trimName: 'V6 SEL with 4MOTION®',
          },
          '2020-acs-v6selrl4mat': {
            trim: '2020-acs-v6selrl4mat',
            trimName: 'V6 SEL R-Line with 4MOTION®',
          },
          '2020-acs-v6selprl4m': {
            trim: '2020-acs-v6selprl4m',
            trimName: 'V6 SEL Premium R-Line with 4MOTION®',
          },
          '2020-atlas-sat': {
            trim: '2020-atlas-sat',
            trimName: 'S',
          },
          '2020-atlas-v6s4mat': {
            trim: '2020-atlas-v6s4mat',
            trimName: 'V6 S with 4MOTION®',
          },
          '2020-golf-tsimt': {
            trim: '2020-golf-tsimt',
            trimName: 'TSI',
          },
          '2020-golfgti-smt': {
            trim: '2020-golfgti-smt',
            trimName: 'S',
          },
          '2020-jettagli-smt': {
            trim: '2020-jettagli-smt',
            trimName: '2.0T S',
          },
          '2019-jettagli-smt': {
            trim: '2019-jettagli-smt',
            trimName: '2.0T S',
          },
          '2020-atlas-all': {
            trim: '2020-atlas-all',
            trimName: 'All',
          },
          '2020-atlas-seat': {
            trim: '2020-atlas-seat',
            trimName: 'SE - Automatic Transmission',
          },
          '2020-atlas-sewtat': {
            trim: '2020-atlas-sewtat',
            trimName: 'SE Tech - Automatic Transmission',
          },
          '2020-atlas-selat': {
            trim: '2020-atlas-selat',
            trimName: 'SEL - Automatic Transmission',
          },
          '2020-atlas-v6seat': {
            trim: '2020-atlas-v6seat',
            trimName: 'V6 SE - Automatic Transmission',
          },
          '2020-atlas-v6se4mat': {
            trim: '2020-atlas-v6se4mat',
            trimName: 'V6 SE with 4MOTION® - Automatic Transmission',
          },
          '2020-atlas-v6setechat': {
            trim: '2020-atlas-v6setechat',
            trimName: 'V6 SE Tech - Automatic Transmission',
          },
          '2020-atlas-v6setech4mat': {
            trim: '2020-atlas-v6setech4mat',
            trimName: 'V6 SE Tech with 4MOTION® - Automatic Transmission',
          },
          '2020-atlas-v6setechrlat': {
            trim: '2020-atlas-v6setechrlat',
            trimName: 'V6 SE Tech R-Line - Automatic Transmission',
          },
          '2020-atlas-v6setechrl4mat': {
            trim: '2020-atlas-v6setechrl4mat',
            trimName:
              'V6 SE Tech R-Line with 4MOTION® - Automatic Transmission',
          },
          '2020-atlas-v6selat': {
            trim: '2020-atlas-v6selat',
            trimName: 'V6 SEL - Automatic Transmission',
          },
          '2020-atlas-v6sel4mat': {
            trim: '2020-atlas-v6sel4mat',
            trimName: 'V6 SEL with 4MOTION® - Automatic Transmission',
          },
          '2020-atlas-v6selrlat': {
            trim: '2020-atlas-v6selrlat',
            trimName: 'V6 SEL R-Line - Automatic Transmission',
          },
          '2020-atlas-v6selrl4mat': {
            trim: '2020-atlas-v6selrl4mat',
            trimName: 'V6 SEL R-Line with 4MOTION® - Automatic Transmission',
          },
          '2020-atlas-v6selp4mat': {
            trim: '2020-atlas-v6selp4mat',
            trimName: 'V6 SEL Premium with 4MOTION® - Automatic Transmission',
          },
          '2020-jettagli-All': {
            trim: '2020-jettagli-All',
            trimName: 'All',
          },
          '2020-jettagli-sat': {
            trim: '2020-jettagli-sat',
            trimName: 'S - Automatic Transmission',
          },
          '2020-jettagli-autobahnmt': {
            trim: '2020-jettagli-autobahnmt',
            trimName: 'Autobahn - Manual Transmission',
          },
          '2020-jettagli-autobahnat': {
            trim: '2020-jettagli-autobahnat',
            trimName: 'Autobahn - Automatic Transmission',
          },
          '2020-tiguan-all': {
            trim: '2020-tiguan-all',
            trimName: 'All',
          },
          '2020-tiguan-serlbat': {
            trim: '2020-tiguan-serlbat',
            trimName: 'SE R-Line - Automatic Transmission',
          },
          '2020-tiguan-serlb4mat': {
            trim: '2020-tiguan-serlb4mat',
            trimName: 'SE R-Line with 4MOTION® - Automatic Transmission',
          },
          '2020-passat-all': {
            trim: '2020-passat-all',
            trimName: 'All',
          },
          '2020-arteon-all': {
            trim: '2020-arteon-all',
            trimName: 'All',
          },
          '2020-arteon-se4mat': {
            trim: '2020-arteon-se4mat',
            trimName: 'SE with 4MOTION® - Automatic Transmission',
          },
          '2020-arteon-seat': {
            trim: '2020-arteon-seat',
            trimName: 'SE - Automatic Transmission',
          },
          '2020-arteon-sel4mat': {
            trim: '2020-arteon-sel4mat',
            trimName: 'SEL 4MOTION® - Automatic Transmission',
          },
          '2020-arteon-selat': {
            trim: '2020-arteon-selat',
            trimName: 'SEL - Automatic Transmission',
          },
          '2020-arteon-sel4mrat': {
            trim: '2020-arteon-sel4mrat',
            trimName: 'SEL with 4MOTION® - Automatic Transmission',
          },
          '2020-arteon-selrat': {
            trim: '2020-arteon-selrat',
            trimName: 'SEL R-Line - Automatic Transmission',
          },
          '2020-arteon-selp4mrat': {
            trim: '2020-arteon-selp4mrat',
            trimName: 'SEL Premium with 4MOTION® - Automatic Transmission',
          },
          '2021-atlas-all': {
            trim: '2021-atlas-all',
            trimName: 'All',
          },
          '2021-atlas-sat': {
            trim: '2021-atlas-sat',
            trimName: 'S - Automatic Transmission',
          },
          '2021-atlas-s4mat': {
            trim: '2021-atlas-s4mat',
            trimName: 'S with 4MOTION® - Automatic Transmission',
          },
          '2021-atlas-seat': {
            trim: '2021-atlas-seat',
            trimName: 'SE - Automatic Transmission',
          },
          '2021-atlas-se4mat': {
            trim: '2021-atlas-se4mat',
            trimName: 'SE with 4MOTION® - Automatic Transmission',
          },
          '2021-atlas-setechat': {
            trim: '2021-atlas-setechat',
            trimName: 'SE Tech - Automatic Transmission',
          },
          '2021-atlas-setech4mat': {
            trim: '2021-atlas-setech4mat',
            trimName: 'SE Tech with 4MOTION® - Automatic Transmission',
          },
          '2021-atlas-sel4mat': {
            trim: '2021-atlas-sel4mat',
            trimName: 'SEL with 4MOTION® - Automatic Transmission',
          },
          '2021-atlas-v6setechat': {
            trim: '2021-atlas-v6setechat',
            trimName: 'v6 SE Tech - Automatic Transmission',
          },
          '2021-atlas-v6setech4mat': {
            trim: '2021-atlas-v6setech4mat',
            trimName: 'v6 SE Tech with 4MOTION® - Automatic Transmission',
          },
          '2021-atlas-v6setechrlat': {
            trim: '2021-atlas-v6setechrlat',
            trimName: 'v6 SE Tech with R-Line - Automatic Transmission',
          },
          '2021-atlas-v6setechrl4mat': {
            trim: '2021-atlas-v6setechrl4mat',
            trimName:
              'v6 SE Tech with R-Line with 4MOTION® - Automatic Transmission',
          },
          '2021-atlas-v6selat': {
            trim: '2021-atlas-v6selat',
            trimName: 'v6 SEL - Automatic Transmission',
          },
          '2021-atlas-v6sel4mat': {
            trim: '2021-atlas-v6sel4mat',
            trimName: 'v6 SEL with 4MOTION® - Automatic Transmission',
          },
          '2021-atlas-v6selrlat': {
            trim: '2021-atlas-v6selrlat',
            trimName: 'v6 SEL R-Line - Automatic Transmission',
          },
          '2021-atlas-v6selrl4mat': {
            trim: '2021-atlas-v6selrl4mat',
            trimName: 'v6 SEL R-Line with 4MOTION® - Automatic Transmission',
          },
          '2021-atlas-selp4mat': {
            trim: '2021-atlas-selp4mat',
            trimName: 'SEL Premium with 4MOTION® - Automatic Transmission',
          },
          '2021-atlas-v6selp4mat': {
            trim: '2021-atlas-v6selp4mat',
            trimName: 'v6 SEL Premium with 4MOTION® - Automatic Transmission',
          },
          '2021-atlas-all215': {
            trim: '2021-atlas-all215',
            trimName: 'ALL 21.5',
          },
          '2021-atlas-s215at': {
            trim: '2021-atlas-s215at',
            trimName: 'S 21.5',
          },
          '2021-atlas-s4m215at': {
            trim: '2021-atlas-s4m215at',
            trimName: 'S with 4MOTION® 21.5',
          },
          '2021-atlas-se215at': {
            trim: '2021-atlas-se215at',
            trimName: 'SE 21.5',
          },
          '2021-atlas-se4m215at': {
            trim: '2021-atlas-se4m215at',
            trimName: 'SE with 4MOTION® 21.5',
          },
          '2021-atlas-setech215at': {
            trim: '2021-atlas-setech215at',
            trimName: 'SE Tech 21.5',
          },
          '2021-atlas-setech4m215at': {
            trim: '2021-atlas-setech4m215at',
            trimName: 'SE Tech with 4MOTION® 21.5',
          },
          '2021-atlas-sel4m215at': {
            trim: '2021-atlas-sel4m215at',
            trimName: 'SEL with 4MOTION® 21.5',
          },
          '2021-atlas-selp4m215at': {
            trim: '2021-atlas-selp4m215at',
            trimName: 'SEL Premium with 4MOTION® 21.5',
          },
          '2021-atlas-v6setech215at': {
            trim: '2021-atlas-v6setech215at',
            trimName: 'V6 SE Tech 21.5',
          },
          '2021-atlas-v6setech4m215at': {
            trim: '2021-atlas-v6setech4m215at',
            trimName: 'V6 SE Tech with 4MOTION® 21.5',
          },
          '2021-atlas-v6setechrl215at': {
            trim: '2021-atlas-v6setechrl215at',
            trimName: 'V6 SE Tech R-Line 21.5',
          },
          '2021-atlas-v6setechrl4m215at': {
            trim: '2021-atlas-v6setechrl4m215at',
            trimName: 'V6 SE Tech R-Line with 4MOTION® 21.5',
          },
          '2021-atlas-v6sel215at': {
            trim: '2021-atlas-v6sel215at',
            trimName: 'V6 SEL 21.5',
          },
          '2021-atlas-v6sel4m215at': {
            trim: '2021-atlas-v6sel4m215at',
            trimName: 'V6 SEL with 4MOTION® 21.5',
          },
          '2021-atlas-v6selrl215at': {
            trim: '2021-atlas-v6selrl215at',
            trimName: 'V6 SEL R-Line 21.5',
          },
          '2021-atlas-v6selrl4m215at': {
            trim: '2021-atlas-v6selrl4m215at',
            trimName: 'V6 SEL R-Line with 4MOTION® 21.5',
          },
          '2021-atlas-v6selp4m215at': {
            trim: '2021-atlas-v6selp4m215at',
            trimName: 'V6 SEL Premium with 4MOTION® 21.5',
          },
          '2021-atlas-v6selprl4m215at': {
            trim: '2021-atlas-v6selprl4m215at',
            trimName: 'V6 SEL Premium R-Line with 4MOTION® 21.5',
          },
          '2021-atlas-v6selprl4mat': {
            trim: '2021-atlas-v6selprl4mat',
            trimName: 'V6 SEL Premium R-Line with 4MOTION®',
          },
          '2021-acs-all': {
            trim: '2021-acs-all',
            trimName: 'ALL',
          },
          '2021-acs-sat': {
            trim: '2021-acs-sat',
            trimName: 'S',
          },
          '2021-acs-s4mat': {
            trim: '2021-acs-s4mat',
            trimName: 'S with 4MOTION®',
          },
          '2021-acs-seat': {
            trim: '2021-acs-seat',
            trimName: 'SE',
          },
          '2021-acs-se4mat': {
            trim: '2021-acs-se4mat',
            trimName: 'SE with 4MOTION®',
          },
          '2021-acs-sewtat': {
            trim: '2021-acs-sewtat',
            trimName: 'SE Tech',
          },
          '2021-acs-sewt4mat': {
            trim: '2021-acs-sewt4mat',
            trimName: 'SE Tech with 4MOTION®',
          },
          '2021-acs-sel4mat': {
            trim: '2021-acs-sel4mat',
            trimName: 'SEL with 4MOTION®',
          },
          '2021-acs-selp4m': {
            trim: '2021-acs-selp4m',
            trimName: 'SEL Premium with 4MOTION®',
          },
          '2021-acs-v6sewt': {
            trim: '2021-acs-v6sewt',
            trimName: 'V6 SE Tech',
          },
          '2021-acs-v6sewt4mat': {
            trim: '2021-acs-v6sewt4mat',
            trimName: 'V6 SE Tech with 4MOTION®',
          },
          '2021-acs-v6sewtrl': {
            trim: '2021-acs-v6sewtrl',
            trimName: 'V6 SE Tech R-Line',
          },
          '2021-acs-v6sewtrl4m': {
            trim: '2021-acs-v6sewtrl4m',
            trimName: 'V6 SE Tech R-Line with 4MOTION®',
          },
          '2021-acs-v6sel': {
            trim: '2021-acs-v6sel',
            trimName: 'V6 SEL',
          },
          '2021-acs-v6sel4mat': {
            trim: '2021-acs-v6sel4mat',
            trimName: 'V6 SEL with 4MOTION®',
          },
          '2021-acs-v6selrl': {
            trim: '2021-acs-v6selrl',
            trimName: 'V6 SEL R-Line',
          },
          '2021-acs-v6selrl4mat': {
            trim: '2021-acs-v6selrl4mat',
            trimName: 'V6 SEL R-Line with 4MOTION®',
          },
          '2021-acs-v6selp4mat': {
            trim: '2021-acs-v6selp4mat',
            trimName: 'V6 SEL Premium 4MOTION®',
          },
          '2021-acs-v6selprl4m': {
            trim: '2021-acs-v6selprl4m',
            trimName: 'V6 SEL Premium R-Line with 4MOTION®',
          },
          '2021-jetta-all': {
            trim: '2021-jetta-all',
            trimName: 'ALL',
          },
          '2021-jetta-smt': {
            trim: '2021-jetta-smt',
            trimName: '1.4T S',
          },
          '2021-jetta-sat': {
            trim: '2021-jetta-sat',
            trimName: '1.4T S',
          },
          '2021-jetta-seat': {
            trim: '2021-jetta-seat',
            trimName: '1.4T SE',
          },
          '2021-jetta-selat': {
            trim: '2021-jetta-selat',
            trimName: '1.4T SEL',
          },
          '2021-jetta-selpat': {
            trim: '2021-jetta-selpat',
            trimName: '1.4T SEL Premium',
          },
          '2021-jetta-rlmt': {
            trim: '2021-jetta-rlmt',
            trimName: '1.4T R-Line',
          },
          '2021-jetta-rlat': {
            trim: '2021-jetta-rlat',
            trimName: '1.4T R-Line',
          },
          '2021-jettagli-all': {
            trim: '2021-jettagli-all',
            trimName: 'ALL',
          },
          '2021-jettagli-smt': {
            trim: '2021-jettagli-smt',
            trimName: '2.0T S',
          },
          '2021-jettagli-sat': {
            trim: '2021-jettagli-sat',
            trimName: '2.0T S',
          },
          '2021-jettagli-autobahnmt': {
            trim: '2021-jettagli-autobahnmt',
            trimName: '2.0T Autobahn',
          },
          '2021-jettagli-autobahnat': {
            trim: '2021-jettagli-autobahnat',
            trimName: '2.0T Autobahn',
          },
          '2021-tiguan-all': {
            trim: '2021-tiguan-all',
            trimName: 'ALL',
          },
          '2021-tiguan-sat': {
            trim: '2021-tiguan-sat',
            trimName: 'S',
          },
          '2021-tiguan-s4mat': {
            trim: '2021-tiguan-s4mat',
            trimName: 'S with 4MOTION®',
          },
          '2021-tiguan-seat': {
            trim: '2021-tiguan-seat',
            trimName: 'SE',
          },
          '2021-tiguan-se4mat': {
            trim: '2021-tiguan-se4mat',
            trimName: 'SE with 4MOTION®',
          },
          '2021-tiguan-selat': {
            trim: '2021-tiguan-selat',
            trimName: 'SEL',
          },
          '2021-tiguan-sel4mat': {
            trim: '2021-tiguan-sel4mat',
            trimName: 'SEL with 4MOTION®',
          },
          '2021-tiguan-serlbat': {
            trim: '2021-tiguan-serlbat',
            trimName: 'SE R-Line Black Package',
          },
          '2021-tiguan-serlb4mat': {
            trim: '2021-tiguan-serlb4mat',
            trimName: 'SE R-Line Black Package with 4MOTION®',
          },
          '2021-tiguan-selp4m': {
            trim: '2021-tiguan-selp4m',
            trimName: 'SEL Premium R-Line with 4MOTION®',
          },
          '2021-passat-all': {
            trim: '2021-passat-all',
            trimName: 'ALL',
          },
          '2021-passat-sat': {
            trim: '2021-passat-sat',
            trimName: '2.0T S',
          },
          '2021-passat-seat': {
            trim: '2021-passat-seat',
            trimName: '2.0T SE',
          },
          '2021-passat-rlineat': {
            trim: '2021-passat-rlineat',
            trimName: '2.0T R-Line ',
          },
          '2021-id4-1steditionat': {
            trim: '1steditionat',
            trimName: '1st EDITION',
          },
          '2021-id4-proat': {
            trim: 'proat',
            trimName: 'PRO',
          },
          '2021-id4-awdproat': {
            trim: 'awdproat',
            trimName: 'AWD PRO',
          },
          '2021-id4-sproat': {
            trim: 'sproat',
            trimName: 'PRO S',
          },
          '2021-id4-sawdproat': {
            trim: 'sawdproat',
            trimName: 'AWD PRO S',
          },
          '2022-taos-sat': {
            trim: 'sat',
            trimName: 'S',
          },
          '2022-taos-s4mat': {
            trim: 's4mat',
            trimName: 'S with 4MOTION®',
          },
          '2022-taos-seat': {
            trim: 'seat',
            trimName: 'SE',
          },
          '2022-taos-se4mat': {
            trim: 'se4mat',
            trimName: 'SE with 4MOTION®',
          },
          '2022-taos-selat': {
            trim: 'selat',
            trimName: 'SEL',
          },
          '2022-taos-sel4mat': {
            trim: 'sel4mat',
            trimName: 'SEL with 4MOTION®',
          },
          '2022-passat-all': {
            trim: '2022-passat-all',
            trimName: 'ALL',
          },
          '2022-passat-seat': {
            trim: '2022-passat-seat',
            trimName: '2.0T SE',
          },
          '2022-passat-rlineat': {
            trim: '2022-passat-rlineat',
            trimName: '2.0T R-Line ',
          },
          '2022-passat-sat': {
            trim: '2022-passat-leat',
            trimName: '2.0T Limited Edition',
          },
          '2022-acs-all': {
            trim: '2022-acs-all',
            trimName: 'ALL',
          },
          '2022-acs-seat': {
            trim: '2022-acs-seat',
            trimName: 'SE',
          },
          '2022-acs-se4mat': {
            trim: '2022-acs-se4mat',
            trimName: 'SE with 4MOTION®',
          },
          '2022-acs-sewtat': {
            trim: '2022-acs-sewtat',
            trimName: 'SE Tech',
          },
          '2022-acs-sewt4mat': {
            trim: '2022-acs-sewt4mat',
            trimName: 'SE Tech with 4MOTION®',
          },
          '2022-acs-v6sewt': {
            trim: '2022-acs-v6sewt',
            trimName: 'V6 SE Tech',
          },
          '2022-acs-v6sewt4mat': {
            trim: '2022-acs-v6sewt4mat',
            trimName: 'V6 SE Tech with 4MOTION®',
          },
          '2022-acs-sel4mat': {
            trim: '2022-acs-sel4mat',
            trimName: 'SEL with 4MOTION®',
          },
          '2022-acs-v6sel4mat': {
            trim: '2022-acs-v6sel4mat',
            trimName: 'V6 SEL with 4MOTION®',
          },
          '2022-acs-selrl4mat': {
            trim: '2022-acs-selrl4mat',
            trimName: 'SEL R-Line with 4MOTION®',
          },
          '2022-acs-v6selrl4mat': {
            trim: '2022-acs-v6selrl4mat',
            trimName: 'V6 SEL R-Line with 4MOTION®',
          },
          '2022-acs-selrlb4mat': {
            trim: '2022-acs-selrlb4mat',
            trimName: 'SEL R-Line Black with 4MOTION®',
          },
          '2022-acs-v6selrlb4mat': {
            trim: '2022-acs-v6selrlb4mat',
            trimName: 'V6 SEL R-Line Black with 4MOTION®',
          },
          '2022-acs-v6selprl4m': {
            trim: '2022-acs-v6selprl4m',
            trimName: 'V6 SEL Premium R-Line with 4MOTION®',
          },
          '2022-acs-v6selprl4mat': {
            trim: '2022-acs-v6selprl4mat',
            trimName: 'V6 SEL Premium R-Line with 4MOTION&reg;',
          },
          '2022-atlas-all': {
            trim: '2022-atlas-all',
            trimName: 'ALL',
          },
          '2022-atlas-seat': {
            trim: '2022-atlas-seat',
            trimName: 'SE',
          },
          '2022-atlas-se4mat': {
            trim: '2022-atlas-se4mat',
            trimName: 'SE with 4MOTION®',
          },
          '2022-atlas-setechat': {
            trim: '2022-atlas-setechat',
            trimName: 'SE Tech',
          },
          '2022-atlas-setech4mat': {
            trim: '2022-atlas-setech4mat',
            trimName: 'SE Tech with 4MOTION®',
          },
          '2022-atlas-v6setechat': {
            trim: '2022-atlas-v6setechat',
            trimName: 'V6 SE Tech',
          },
          '2022-atlas-v6setech4ma': {
            trim: '2022-atlas-v6setech4ma',
            trimName: 'V6 SE Tech with 4MOTION®',
          },
          '2022-atlas-sel4mat': {
            trim: '2022-atlas-sel4mat',
            trimName: 'SEL with 4MOTION®',
          },
          '2022-atlas-v6sel4mat': {
            trim: '2022-atlas-v6sel4mat',
            trimName: 'V6 SEL with 4MOTION®',
          },
          '2022-atlas-v6selrl4mat': {
            trim: '2022-atlas-v6selrl4mat',
            trimName: 'V6 SEL R-Line with 4MOTION®',
          },
          '2022-atlas-v6selrlb4mat': {
            trim: '2022-atlas-v6selrlb4mat',
            trimName: 'V6 SEL R-Line Black with 4MOTION®',
          },
          '2022-atlas-v6selprl4mat': {
            trim: '2022-atlas-v6selprl4mat',
            trimName: 'V6 SEL Premium R-Line with 4MOTION®',
          },
          '2022-tiguan-sat': {
            trim: '2022-tiguan-sat',
            trimName: 'S',
          },
          '2022-tiguan-s4mat': {
            trim: '2022-tiguan-s4mat',
            trimName: 'S with 4MOTION®',
          },
          '2022-tiguan-seat': {
            trim: '2022-tiguan-seat',
            trimName: 'SE',
          },
          '2022-tiguan-se4mat': {
            trim: '2022-tiguan-se4mat',
            trimName: 'SE with 4MOTION®',
          },
          '2022-tiguan-serlbat': {
            trim: '2022-tiguan-serlbat',
            trimName: 'SE R-Line Black Package',
          },
          '2022-tiguan-selp4m': {
            trim: '2022-tiguan-selp4m',
            trimName: 'SEL R-Line with 4MOTION®',
          },
          '2022-golfgti-all': {
            trim: '2022-golfgti-all',
            trimName: 'ALL',
          },
          '2022-golfgti-smt': {
            trim: '2022-golfgti-smt',
            trimName: 'S',
          },
          '2022-golfgti-sat': {
            trim: '2022-golfgti-sat',
            trimName: 'S',
          },
          '2022-golfgti-semt': {
            trim: '2022-golfgti-semt',
            trimName: 'SE',
          },
          '2022-golfgti-seat': {
            trim: '2022-golfgti-seat',
            trimName: 'SE',
          },
          '2022-golfgti-abat': {
            trim: '2022-golfgti-abat',
            trimName: 'Autobahn',
          },
          '2022-golfgti-abmt': {
            trim: '2022-golfgti-abmt',
            trimName: 'Autobahn',
          },
          '2022-arteon-all': {
            trim: '2022-arteon-all',
            trimName: 'ALL',
          },
          '2022-arteon-seat': {
            trim: '2022-arteon-seat',
            trimName: '2.0T SE R-Line',
          },
          '2022-arteon-sel4mrat': {
            trim: '2022-arteon-sel4mrat',
            trimName: '2.0T SEL R-Line with 4MOTION®',
          },
          '2022-arteon-selp4mrat': {
            trim: '2022-arteon-selp4mrat',
            trimName: '2.0T SEL Premium R-Line with 4MOTION®',
          },
          '2022-golfr-all': {
            trim: '2022-golfr-all',
            trimName: 'ALL',
          },
          '2022-golfr-4mmt': {
            trim: '2022-golfr-4mmt',
            trimName: '6-speed Manual',
          },
          '2022-golfr-4mat': {
            trim: '2022-golfr-4mat',
            trimName: '7-speed DSG Automatic w/ Tiptronic',
          },
          '2022-jetta-all': {
            trim: '2022-jetta-all',
            trimName: 'ALL',
          },
          '2022-jetta-smt': {
            trim: '2022-jetta-smt',
            trimName: '1.5T S',
          },
          '2022-jetta-sat': {
            trim: '2022-jetta-sat',
            trimName: '1.5T S',
          },
          '2022-jetta-sprtmt': {
            trim: '2022-jetta-sprtmt',
            trimName: '1.5T Sport',
          },
          '2022-jetta-sprtat': {
            trim: '2022-jetta-sprtat',
            trimName: '1.5T Sport',
          },
          '2022-jetta-seat': {
            trim: '2022-jetta-seat',
            trimName: '1.5T SE',
          },
          '2022-jetta-selat': {
            trim: '2022-jetta-selat',
            trimName: '1.5T SEL',
          },
          '2022-jettagli-all': {
            trim: '2022-jettagli-all',
            trimName: 'ALL',
          },
          '2022-jettagli-autobahnmt': {
            trim: '2022-jettagli-autobahnmt',
            trimName: '2.0T Autobahn',
          },
          '2022-jettagli-autobahnat': {
            trim: '2022-jettagli-autobahnat',
            trimName: '2.0T Autobahn',
          },
          '2023-acs-all': {
            trim: '2023-acs-all',
            trimName: 'ALL',
            trimInventoryName: 'ALL',
          },
          '2023-acs-seat': {
            trim: '2023-acs-seat',
            trimName: 'SE',
            trimInventoryName: 'SE',
          },
          '2023-acs-se4mat': {
            trim: '2023-acs-se4mat',
            trimName: 'SE with 4MOTION®',
            trimInventoryName: 'SE with 4MOTION®',
          },
          '2023-acs-sewtat': {
            trim: '2023-acs-sewtat',
            trimName: 'SE Tech',
            trimInventoryName: 'SE with Technology',
          },
          '2023-acs-sewt4mat': {
            trim: '2023-acs-sewt4mat',
            trimName: 'SE Tech with 4MOTION®',
            trimInventoryName: 'SE with Technology',
          },
          '2023-acs-v6sewtat': {
            trim: '2023-acs-v6sewtat',
            trimName: 'V6 SE Tech',
            trimInventoryName: 'SE with Technology',
          },
          '2023-acs-v6sewt4mat': {
            trim: '2023-acs-v6sewt4mat',
            trimName: 'V6 SE Tech with 4MOTION®',
            trimInventoryName: 'SE with Technology',
          },
          '2023-acs-sel4mat': {
            trim: '2023-acs-sel4mat',
            trimName: 'SEL with 4MOTION®',
            trimInventoryName: 'SEL',
          },
          '2023-acs-v6sel4mat': {
            trim: '2023-acs-v6sel4mat',
            trimName: 'V6 SEL with 4MOTION®',
            trimInventoryName: 'V6 SEL with 4MOTION®',
          },
          '2023-acs-v6selprl4mat': {
            trim: '2023-acs-v6selprl4mat',
            trimName: 'V6 SEL Premium R-Line with 4MOTION®',
            trimInventoryName: 'SEL Premium R-Line',
          },
          '2023-acs-selrlb4mat': {
            trim: '2023-acs-selrlb4mat',
            trimName: 'SEL R-Line Black with 4MOTION®',
            trimInventoryName: 'SEL R-Line Black',
          },
          '2023-acs-v6selrlb4mat': {
            trim: '2023-acs-v6selrlb4mat',
            trimName: 'V6 SEL R-Line Black with 4MOTION®',
            trimInventoryName: 'SEL R-Line Black',
          },
          '2023-atlas-all': {
            trim: '2023-atlas-all',
            trimName: 'ALL',
            trimInventoryName: 'ALL',
          },
          '2023-atlas-seat': {
            trim: '2023-atlas-seat',
            trimName: 'SE',
            trimInventoryName: 'SE',
          },
          '2023-atlas-se4mat': {
            trim: '2023-atlas-se4mat',
            trimName: 'SE with 4MOTION®',
            trimInventoryName: 'SE with 4MOTION®',
          },
          '2023-atlas-sewtat': {
            trim: '2023-atlas-sewtat',
            trimName: 'SE Tech',
            trimInventoryName: 'SE with Technology',
          },
          '2023-atlas-sewt4mat': {
            trim: '2023-atlas-sewt4mat',
            trimName: 'SE Tech with 4MOTION®',
            trimInventoryName: 'SE with Technology with 4MOTION®',
          },
          '2023-atlas-v6sewtat': {
            trim: '2023-atlas-v6sewtat',
            trimName: 'V6 SE Tech',
            trimInventoryName: 'V6 SE with Technology',
          },
          '2023-atlas-v6sewt4mat': {
            trim: '2023-atlas-v6sewt4mat',
            trimName: 'V6 SE Tech with 4MOTION®',
            trimInventoryName: 'V6 SE with Technology with 4MOTION®',
          },
          '2023-atlas-sel4mat': {
            trim: '2023-atlas-sel4mat',
            trimName: 'SEL with 4MOTION®',
            trimInventoryName: 'SEL with 4MOTION®',
          },
          '2023-atlas-v6sel4mat': {
            trim: '2023-atlas-v6sel4mat',
            trimName: 'V6 SEL with 4MOTION®',
            trimInventoryName: 'V6 SEL with 4MOTION®',
          },
          '2023-atlas-v6selrlb4mat': {
            trim: '2023-atlas-v6selrlb4mat',
            trimName: 'V6 SEL R-Line Black with 4MOTION®',
            trimInventoryName: 'V6 SEL R-Line Black with 4MOTION®',
          },
          '2023-atlas-v6selprl4mat': {
            trim: '2023-atlas-v6selprl4mat',
            trimName: 'V6 SEL Premium R-Line with 4MOTION®',
            trimInventoryName: 'V6 SEL Premium R-Line with 4MOTION®',
          },
          '2023-taos-all': {
            trim: '2023-taos-all',
            trimName: 'ALL',
            trimInventoryName: 'ALL',
          },
          '2023-taos-sat': {
            trim: '2023-taos-sat',
            trimName: 'S',
            trimInventoryName: 'S',
          },
          '2023-taos-s4mat': {
            trim: '2023-taos-s4mat',
            trimName: 'S with 4MOTION®',
            trimInventoryName: 'S with 4MOTION®',
          },
          '2023-taos-seat': {
            trim: '2023-taos-seat',
            trimName: 'SE',
            trimInventoryName: 'SE',
          },
          '2023-taos-se4mat': {
            trim: '2023-taos-se4mat',
            trimName: 'SE with 4MOTION®',
            trimInventoryName: 'SE with 4MOTION®',
          },
          '2023-taos-sel4mat': {
            trim: '2023-taos-sel4mat',
            trimName: 'SEL with 4MOTION®',
            trimInventoryName: 'SEL with 4MOTION®',
          },
          '2023-jetta-all': {
            trim: '2023-jetta-all',
            trimName: 'ALL',
            trimInventoryName: 'ALL',
          },
          '2023-jetta-smt': {
            trim: '2023-jetta-smt',
            trimName: '1.5T S',
            trimInventoryName: 'S',
          },
          '2023-jetta-sat': {
            trim: '2023-jetta-sat',
            trimName: '1.5T S',
            trimInventoryName: 'S',
          },
          '2023-jetta-sprtmt': {
            trim: '2023-jetta-sprtmt',
            trimName: '1.5T Sport',
            trimInventoryName: 'Sport',
          },
          '2023-jetta-sprtat': {
            trim: '2023-jetta-sprtat',
            trimName: '1.5T Sport',
            trimInventoryName: 'Sport',
          },
          '2023-jetta-seat': {
            trim: '2023-jetta-seat',
            trimName: '1.5T SE',
            trimInventoryName: 'SE',
          },
          '2023-jetta-selat': {
            trim: '2023-jetta-selat',
            trimName: '1.5T SEL',
            trimInventoryName: 'SEL',
          },
          '2023-jettagli-all': {
            trim: '2023-jettagli-all',
            trimName: 'ALL',
            trimInventoryName: 'ALL',
          },
          '2023-jettagli-autobahnmt': {
            trim: '2023-jettagli-autobahnmt',
            trimName: '2.0T Autobahn',
            trimInventoryName: 'Autobahn',
          },
          '2023-jettagli-autobahnat': {
            trim: '2023-jettagli-autobahnat',
            trimName: '2.0T Autobahn',
            trimInventoryName: 'Autobahn',
          },
          '2023-arteon-all': {
            trim: '2023-arteon-all',
            trimName: 'ALL',
            trimInventoryName: 'ALL',
          },
          '2023-arteon-seat': {
            trim: '2023-arteon-seat',
            trimName: '2.0T SE R-Line',
            trimInventoryName: 'SE R-Line',
          },
          '2023-arteon-sel4mrat': {
            trim: '2023-arteon-sel4mrat',
            trimName: '2.0T SEL R-Line with 4MOTION®',
            trimInventoryName: 'SEL R-Line with 4MOTION®',
          },
          '2023-arteon-selp4mrat': {
            trim: '2023-arteon-selp4mrat',
            trimName: '2.0T SEL Premium R-Line with 4MOTION®',
            trimInventoryName: 'SEL Premium R-Line with 4MOTION®',
          },
          '2023-tiguan-all': {
            trim: '2023-tiguan-all',
            trimName: 'ALL',
            trimInventoryName: 'ALL',
          },
          '2023-tiguan-sat': {
            trim: '2023-tiguan-sat',
            trimName: 'S',
            trimInventoryName: 'S',
          },
          '2023-tiguan-s4mat': {
            trim: '2023-tiguan-s4mat',
            trimName: 'S with 4MOTION®',
            trimInventoryName: 'S with 4MOTION®',
          },
          '2023-tiguan-seat': {
            trim: '2023-tiguan-seat',
            trimName: 'SE',
            trimInventoryName: 'SE',
          },
          '2023-tiguan-se4mat': {
            trim: '2023-tiguan-se4mat',
            trimName: 'SE with 4MOTION®',
            trimInventoryName: 'SE with 4MOTION®',
          },
          '2023-tiguan-serlbat4m': {
            trim: '2023-tiguan-serlbat4m',
            trimName: 'SE R-Line Black Package with 4MOTION®',
            trimInventoryName: 'SE R-Line Black with 4MOTION®',
          },
          '2023-tiguan-serlbatat': {
            trim: '2023-tiguan-serlbatat',
            trimName: 'SE R-Line Black Package',
            trimInventoryName: 'SE R-Line Black',
          },
          '2023-tiguan-selp4m': {
            trim: '2023-tiguan-selp4m',
            trimName: 'SEL R-Line with 4MOTION®',
            trimInventoryName: 'SEL R-Line with 4MOTION®',
          },
          '2023-golfr-all': {
            trim: '2023-golfr-all',
            trimName: 'ALL',
            trimInventoryName: 'ALL',
          },
          '2023-golfr-4mmt': {
            trim: '2023-golfr-4mmt',
            trimName: '6-speed Manual',
            trimInventoryName: '2.0L Turbo Golf R',
          },
          '2023-golfr-4mat': {
            trim: '2023-golfr-4mat',
            trimName: '2.0L Turbo Golf R',
            trimInventoryName: 'ALL',
          },
          '2023-golfgti-all': {
            trim: '2023-golfgti-all',
            trimName: 'ALL',
            trimInventoryName: 'ALL',
          },
          '2023-golfgti-smt': {
            trim: '2023-golfgti-smt',
            trimName: 'S',
            trimInventoryName: 'S',
          },
          '2023-golfgti-sat': {
            trim: '2023-golfgti-sat',
            trimName: 'S',
            trimInventoryName: 'S',
          },
          '2023-golfgti-semt': {
            trim: '2023-golfgti-semt',
            trimName: 'SE',
            trimInventoryName: 'SE',
          },
          '2023-golfgti-seat': {
            trim: '2023-golfgti-seat',
            trimName: 'SE',
            trimInventoryName: 'SE',
          },
          '2023-golfgti-abat': {
            trim: '2023-golfgti-abat',
            trimName: 'Autobahn',
            trimInventoryName: 'Autobahn',
          },
          '2023-golfgti-abmt': {
            trim: '2023-golfgti-abmt',
            trimName: 'Autobahn',
            trimInventoryName: 'Autobahn',
          },
          '2023-id4-all': {
            trim: '2023-id4-all',
            trimName: 'ALL',
            trimInventoryName: 'ALL',
          },
          '2023-id4-standardat': {
            trim: '2023-id4-standardat',
            trimName: 'Standard',
            trimInventoryName: 'ID.4 Standard',
          },
          '2023-id4-sat': {
            trim: '2023-id4-sat',
            trimName: 'S',
            trimInventoryName: 'ID.4 S',
          },
          '2023-id4-proat': {
            trim: '2023-id4-proat',
            trimName: 'PRO',
            trimInventoryName: 'ID.4 Pro',
          },
          '2023-id4-awdproat': {
            trim: '2023-id4-awdproat',
            trimName: 'AWD PRO',
            trimInventoryName: 'ID.4 AWD Pro',
          },
          '2023-id4-prosat': {
            trim: '2023-id4-prosat',
            trimName: 'PRO S',
            trimInventoryName: 'ID.4 Pro S',
          },
          '2023-id4-awdprosat': {
            trim: '2023-id4-awdprosat',
            trimName: 'AWD PRO S',
            trimInventoryName: 'ID.4 AWD Pro S',
          },
          '2023-id4-prosplusat': {
            trim: '2023-id4-prosplusat',
            trimName: 'PRO S PLUS',
            trimInventoryName: 'ID.4 Pro S Plus',
          },
          '2023-id4-awdprosplusat': {
            trim: '2023-id4-awdprosplusat',
            trimName: 'AWD PRO S PLUS',
            trimInventoryName: 'ID.4 AWD Pro S Plus',
          },
        },
      },
    },
  },
};
